var React = require('react');

function Youtube (props) {
    props = { ...{"viewBox":"0 0 28 20"}, ...props };
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M11.11 13.689l-.002-7.99 7.565 4.01-7.563 3.98zm16.61-9.374s-.274-1.96-1.112-2.823C25.542.359 24.35.353 23.802.287 19.882 0 14.006 0 14.006 0h-.012S8.116 0 4.198.287c-.547.066-1.74.072-2.806 1.205C.552 2.354.28 4.315.28 4.315S0 6.615 0 8.917v2.157c0 2.3.279 4.602.279 4.602s.274 1.96 1.113 2.822c1.066 1.133 2.466 1.098 3.087 1.216C6.72 19.932 14 20 14 20s5.883-.01 9.802-.297c.548-.066 1.74-.072 2.806-1.205.838-.862 1.112-2.822 1.112-2.822s.28-2.301.28-4.602V8.917c0-2.302-.28-4.602-.28-4.602z"}));
}

module.exports = Youtube;

Youtube.default = Youtube;
